export default "__VITE_ASSET__c3b8766d__"